/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import EmptyPage from "layouts/emptyPage"
import Offers from "layouts/tables";
import Billing from "layouts/billing";
import Cashier from "layouts/cashier"
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import RetailerProfile from "layouts/retailerProfile";
import RetailerShops from "layouts/retailerShops"
import RetailerSurveys from "layouts/retailerSurveys"
import RetailerProducts from "layouts/retailerProducts"
import RetailerCampaigns from "layouts/retailerCampaigns"
import RetailerAvatars from "layouts/retailerAvatars";
import ShopReport from "layouts/reports/ShopReport"
import ProductReport from "layouts/reports/ProductReport"
import Reports from "layouts/reports/Reports"
import PredictionsPage from "layouts/predictions/PredictionsPage"
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// @mui icons
import Icon from "@mui/material/Icon";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BallotIcon from '@mui/icons-material/Ballot';
import InventoryIcon from '@mui/icons-material/Inventory';
import CampaignIcon from '@mui/icons-material/Campaign';
import RetailerTransactions from "layouts/retailerTransactions";
import AssessmentIcon from '@mui/icons-material/Assessment';
import InsightsIcon from '@mui/icons-material/Insights';

const routes = [
  {
    type: "collapse",
    name: "Cashier",
    key: "cashier",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/cashier",
    component: <Cashier />,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Offers",
    key: "offers",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/offers",
    component: <Offers />,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <RetailerProfile />,
  },
  {
    type: "collapse",
    name: "Shops",
    key: "shops",
    icon: <ShoppingCartIcon />,
    route: "/shops",
    component: <RetailerShops />,
  },
  {
    type: "collapse",
    name: "Surveys",
    key: "surveys",
    icon: <BallotIcon />,
    route: "/surveys",
    component: <RetailerSurveys />,
  },
  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <InventoryIcon />,
    route: "/products",
    component: <RetailerProducts />,
  },
  {
    type: "collapse",
    name: "Campaigns",
    key: "campaigns",
    icon: <CampaignIcon />,
    route: "/campaigns",
    component: <RetailerCampaigns />,
  },
  {
    type: "collapse",
    name: "Avatars",
    key: "avatars",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/avatars",
    component: <RetailerAvatars />,
  },
  {
    type: "collapse",
    name: "Transactions",
    key: "transactions",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/transactions",
    component: <RetailerTransactions />,
  },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <AssessmentIcon/>,
    route: "/reports",
    component: <Reports />,
  },
  {
    type: "collapse",
    name: "surveyReports",
    key: "surveyReports",
    icon: <AssessmentIcon/>,
    route: "/reports/shop",
    invisible: true,
    component: <ShopReport />,
  },
  {
    type: "collapse",
    name: "ProductReports",
    key: "productReports",
    icon: <AssessmentIcon/>,
    route: "/reports/product",
    invisible: true,
    component: <ProductReport />,
  },
  {
    type: "collapse",
    name: "Predictions",
    key: "predictions",
    icon: <InsightsIcon/>,
    route: "/predictions",
    component: <PredictionsPage />,
  },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "Retailer Surveys",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Retailer Products",
  //   key: "profile",
  //   icon: <Icon fontSize="small"></Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    invisible: true,
    component: <SignIn />,
  },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
];

export default routes;
